/**
 * Licensed Materials - Property of IBM
 * IBM Business Analytics (C) Copyright IBM Corp. 2020
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */


export default class LocalFilterExtensionAPI {
	/**
	 * @function LocalFilterExtensionAPI#render
	 * @description Renders extension UI
	 * @return {object} the UI of the extension
	 */
	render() {}
}



// WEBPACK FOOTER //
// ./src/js/dashboard/LocalFilterExtensionAPI.js